import { createToaster, Toaster as ChakraToaster, Toast, Portal, Stack } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import type { Options as ZagToastOptions } from '@zag-js/toast';

export const toaster = createToaster({
  placement: 'top-end',
  pauseOnPageIdle: true,
});

function renderToast(toast: ZagToastOptions<ReactNode>) {
  return (
    <Toast.Root width={{ md: 'sm' }}>
      <Toast.Indicator />
      <Stack gap="1" flex="1" maxWidth="100%">
        {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
        {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
      </Stack>
      {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
      {toast.meta?.closable && <Toast.CloseTrigger />}
    </Toast.Root>
  );
}

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
        {renderToast}
      </ChakraToaster>
    </Portal>
  );
};
